// Compressão de imagem assíncrona — não bloqueia a UI.
// Estratégia: createImageBitmap (async nativo do browser, cede o event loop) →
// desenha em <canvas> reduzido → exporta JPEG com quality 0.75.
// Reduz uma foto típica de smartphone (3-8MB) pra ~200-500KB sem perda perceptível.
// Fallback: se createImageBitmap falhar (browsers antigos), retorna o File original.

const MAX_DIM = 1600;      // maior dimensão (largura ou altura) após compressão
const QUALITY = 0.75;
const MIN_BYTES = 200_000; // arquivos < 200KB não valem a pena comprimir

export async function compressImageAsync(file) {
  if (!file || !file.type?.startsWith("image/")) return file;
  if (file.size < MIN_BYTES) return file;         // já é pequeno
  if (typeof createImageBitmap !== "function") return file;  // sem suporte
  try {
    // createImageBitmap é async nativo — decodifica no thread do browser sem travar
    const bitmap = await createImageBitmap(file);
    const { width, height } = bitmap;
    const scale = Math.min(1, MAX_DIM / Math.max(width, height));
    const w = Math.round(width * scale);
    const h = Math.round(height * scale);
    // OffscreenCanvas roda em worker onde disponível — cede completamente o main thread
    const canvas = typeof OffscreenCanvas !== "undefined"
      ? new OffscreenCanvas(w, h)
      : Object.assign(document.createElement("canvas"), { width: w, height: h });
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, w, h);
    bitmap.close?.();  // libera memória do bitmap imediatamente
    const blob = canvas.convertToBlob
      ? await canvas.convertToBlob({ type: "image/jpeg", quality: QUALITY })
      : await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", QUALITY));
    if (!blob || blob.size >= file.size) return file;  // compressão não valeu a pena
    // Preserva o nome original mas força .jpg
    const newName = (file.name || "evidencia").replace(/\.[^/.]+$/, "") + ".jpg";
    return new File([blob], newName, { type: "image/jpeg", lastModified: Date.now() });
  } catch { return file; }  // qualquer erro → mantém arquivo original (upload ainda funciona)
}
